import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UserForm from './UserForm';

class Create extends Component {
  render() {
    const {
      isModalOpen,
      onCloseHandler,
      searchValue,
      searchQuery,
    } = this.props;
    return (
      <UserForm
        isModalOpen={isModalOpen}
        onCloseHandler={onCloseHandler}
        searchValue={searchValue}
        searchQuery={searchQuery}
      />
    );
  }
}

Create.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  searchValue: PropTypes.string,
  searchQuery: PropTypes.func,
};

Create.defaultProps = {
  isModalOpen: false,
  onCloseHandler: () => {},
  searchValue: '',
  searchQuery: () => {},
};

export default Create;
